/**
 * @file Require valid slug higher order component.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';

import { AccountBySlug } from '../../graphql/queries/account';
import NotFound from '../../apps/pro/views/NotFound';

// The app uses a few of its own top level paths
const APP_SLUGS = ['galleries', 'g'];

const withValidSlug = WrappedComponent =>
  class WithValidSlugWrapper extends Component {
    static propTypes = {
      loading: PropTypes.bool,
      account: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
      match: PropTypes.shape({
        params: PropTypes.shape({
          slug: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    };

    render() {
      const { loading, account, match, ...props } = this.props;

      if (loading) {
        return null;
      }

      return account || APP_SLUGS.includes(match.params.slug) ? (
        <WrappedComponent {...props} />
      ) : (
        <NotFound />
      );
    }
  };

const RequireValidSlug = WrappedComponent => {
  const withAccountBySlug = graphql(AccountBySlug, {
    options: ({ match }) => ({
      variables: {
        slug: match.params.slug,
      },
    }),
    props: ({ data: { loading, accountBySlug } }) => ({
      loading,
      account: accountBySlug,
    }),
    skip: ({ match }) => APP_SLUGS.includes(match.params.slug),
  });

  return compose(
    withRouter,
    withAccountBySlug,
    withValidSlug,
  )(WrappedComponent);
};

export default RequireValidSlug;
